import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles((theme) => ({
  margRight: {
    paddingRight: 144,
    [theme.breakpoints.down('sm')]: {
      paddingRight: 100,
    },
  },
  icon: {
    height: theme.spacing(2),
    width: theme.spacing(2),
    verticalAlign: 'text-bottom',
    marginRight: theme.spacing(0.5),
  },
  displayScores: {
    display: 'flex',
    [theme.breakpoints.down('lg')]: {
      flexDirection: 'column',
    },
  },
  hideXSmall: {
    display: 'none',
    [theme.breakpoints.up('md')]: {
      display: 'inherit',
    },
  },
  row: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'flex-start',
  },
  padLeft: {
    paddingLeft: theme.spacing(1),
  },
}));

export default useStyles;
